// extracted by mini-css-extract-plugin
var _1 = "GgHzM";
var _2 = "EmdGf";
var _3 = "h5M4N";
var _4 = "uz227";
var _5 = "rclHC";
var _6 = "OiyDj";
export { _1 as "inSearchInputPlaceholder", _2 as "inputPlaceholder", _3 as "isDisabled", _4 as "searchBoxInput", _5 as "searchBoxInputContainer", _6 as "win32SearchBoxInput" }
